/** Your own status: activity (or the app in front) means online, inactivity idle, unless do not disturb is on. */
export function createPresence(send) {
    let status = 'online';
    let doNotDisturb = false;
    /** The server assumes a new socket's app is in front. */
    let focused = true;
    function set(next) {
        if (next === status)
            return;
        status = next;
        send({ type: 'presence.set', status });
    }
    return {
        /** Do not disturb is chosen by hand and wins over idle detection. */
        setDoNotDisturb(on) {
            doNotDisturb = on;
            set(on ? 'dnd' : 'online');
        },
        reportActivity(active) {
            if (!doNotDisturb)
                set(active ? 'online' : 'idle');
        },
        /** Whether the app is in front (window focused, phone app open): while it is, the phone gets no push. */
        reportFocus(next) {
            if (next === focused)
                return;
            focused = next;
            send({ type: 'focus.set', focused });
        },
        /** A new socket starts as online and in front on the server; tell it otherwise if needed. */
        resendPresence() {
            if (status !== 'online')
                send({ type: 'presence.set', status });
            if (!focused)
                send({ type: 'focus.set', focused });
        },
    };
}
//# sourceMappingURL=presence.js.map